// extracted by mini-css-extract-plugin
module.exports = {"partner":"styles_partner__13cWi"};